import { Icon, IconProps } from '@chakra-ui/icons'

const SituationalIcon = (props: IconProps) => {
  return (
    <Icon
      viewBox="0 0 21 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={'#343A40'}
      {...props}
    >
      <path
        d="M13.5 5H6C3.791 5 2 6.791 2 9V18C2 20.209 3.791 22 6 22H15C17.209 22 19 20.209 19 18V10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 10V11.172"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 15.8281V17.0001"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47302 11.7501L8.48702 12.3281"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5299 14.6719L13.5269 15.2499"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47302 15.2499L8.48702 14.6719"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5299 12.3281L13.5269 11.7501"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.5 11.1641C11.79 11.1641 12.834 12.2101 12.834 13.4981C12.834 14.7861 11.79 15.8321 10.5 15.8321C9.21002 15.8321 8.16602 14.7881 8.16602 13.4981C8.16602 12.2081 9.21002 11.1641 10.5 11.1641"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 10C15.7912 10 14 8.2096 14 6C14 3.8368 15.84 1.9976 18.0032 2C20.2112 2.0016 22 3.792 22 6C22 8.2088 20.2096 10 18 10"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 6.20312V7.80313"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9992 4.21849C17.9376 4.21849 17.888 4.26809 17.8888 4.32969C17.8888 4.39129 17.9384 4.44089 18 4.44089C18.0616 4.44089 18.1112 4.39129 18.1112 4.32969C18.1112 4.26809 18.0616 4.21849 17.9992 4.21849"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

export default SituationalIcon
